import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { HeadingContext } from "../../context/HeadingContext";
import CustomModal from "../../widgets/CustomModal";
import CustomFileUpload from "../../widgets/CustomFileUpload";
import ImageCropper from "../../widgets/ImageCropper"; // Import ImageCropper
import CustomBtn from "../../widgets/CustomBtn";

// Importing image assets
import editImg from "../../../assets/images/edit.png";
import logoImg from "../../../assets/images/lociLogo.png";

import { updateOrganization } from "../../_slice/organizationSlice";
import { addImage } from "../../_slice/onboardingSlice";
import AppContext from "../../context/AppContext";

function Organization() {
  const { setHeading } = useContext(HeadingContext); // Context to set the page heading
  const [modalShow, setModalShow] = useState(false); // State to manage the visibility of the modal
  const [checkedState, setCheckedState] = useState({}); // State to manage the checked state of checkboxes
  const [orgName, setOrgName] = useState(""); // State to manage organization name input
  const [orgNameError, setOrgNameError] = useState(false); // State to manage organization name validation error
  const [webSiteName, setWebSiteName] = useState(""); // State to manage organization name input
  const [webSiteNameError, setWebSiteNameError] = useState(false); // State to manage organization name validation error
  const [logoError, setLogoError] = useState(false); // State to manage logo validation error
  const { setLoader } = useContext(AppContext); // Context to manage loading state
  const navigate = useNavigate(); // Hook to navigate programmatically
  const location = useLocation(); // Hook to get the current location

  const dispatch = useDispatch(); // Hook to dispatch actions
  // Extracting imgData key from Redux state
  const imgDataKey = useSelector((state) => state?.onboarding?.imgData?.key);

  // State to manage file upload
  const [file, setFile] = useState({
    viewImg: null, // URL of the selected image for preview
    uploadedImg: null, // Key of the uploaded image
  });

  // Selector to get organization data from the Redux state
  const organizationData = useSelector((state) => {
    return state?.organization?.organizationData?.organisation;
  });

  const [showCropper, setShowCropper] = useState(false); // State to manage cropping
  const [croppedImage, setCroppedImage] = useState(null);

  // Effect to set the page heading on component mount and update based on location state
  useEffect(() => {
    // if (location?.state?.orgId) {
    //   setCheckedState(prevState => ({
    //     ...prevState,
    //     [location.state.orgId]: true
    //   }));
    // }
    setHeading("Organization");
  }, [setHeading, location?.state?.orgId]);

  // Handler for checkbox change
  const handleCheckboxChange = (event, id) => {
    const checked = event.target.checked;
    setCheckedState((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
    if (checked) {
      navigate("/organization/campus", {
        state: { orgId: organizationData?.id },
      });
    }
    sessionStorage.clear();
  };

  // Effect to update file state when imgDataKey changes
  useEffect(() => {
    if (imgDataKey) {
      setFile((prevFile) => ({ ...prevFile, uploadedImg: imgDataKey }));
    }
  }, [imgDataKey]);

  // Handler to open the edit modal with pre-filled data
  const handleEditClick = () => {
    setShowCropper(false);
    setOrgName(organizationData?.name || "");
    setWebSiteName(organizationData?.website || "");
    setFile({
      viewImg: organizationData?.logo
        ? process.env.REACT_APP_MEDIA_URL_ORG + organizationData.logo
        : null,
      uploadedImg: organizationData?.logo || null,
    });
    setModalShow(true);
  };

  // Handler to save organization data
  const handleSave = () => {
    if (!orgName.trim()) {
      setOrgNameError(true); // Set error if organization name is not filled
      return;
    }
    // if (!webSiteName.trim()) {
    //   setWebSiteNameError(true); // Set error if website name is not filled
    //   return;
    // }
    if (!file.uploadedImg) {
      setLogoError(true); // Set error if logo is not uploaded
      return;
    }

    // Dispatch update organization action
    dispatch(
      updateOrganization({
        orgName,
        webSiteName,
        logo: file?.uploadedImg,
        navigate,
        setLoader,
      })
    ).then(() => {
      setModalShow(false);
    });
  };

  // Handler to manage file change for logo upload
  // const handleFileChange = (selectedFile) => {
  //   setFile({ ...file, viewImg: URL.createObjectURL(selectedFile) });
  //   const formData = new FormData();
  //   formData.append('image', selectedFile);
  //   formData.append('type', 'org_logo');
  //   dispatch(addImage({ formData, setLoader }));
  //   setLogoError(false); // Reset logo error when a file is selected
  // };

  // // Effect to reset form values and clear errors when the modal is closed
  // useEffect(() => {
  //   if (!modalShow) {
  //     setOrgNameError(false); // Reset organization name error when modal is closed
  //     setLogoError(false); // Reset logo error when modal is closed
  //   }
  // }, [modalShow]);

  const handleFileChange = (selectedFile) => {
    setFile({ ...file, viewImg: URL.createObjectURL(selectedFile) });
    setShowCropper(true); // Show cropper when a file is selected
    setLogoError(false);
  };

  const handleCropComplete = (croppedBlob) => {
    const croppedUrl = URL.createObjectURL(croppedBlob);
    setCroppedImage(croppedUrl); // Set the cropped image URL for display

    const formData = new FormData();
    formData.append("image", croppedBlob);
    formData.append("type", "org_logo");
    dispatch(addImage({ formData, setLoader }));

    setShowCropper(false); // Hide the cropper
    setFile((prevFile) => ({
      ...prevFile,
      viewImg: croppedUrl,
      uploadedImg: croppedBlob,
    })); // Update file state with cropped image
    setLogoError(false);
  };

  useEffect(() => {
    if (!modalShow) {
      setOrgNameError(false);
      // setWebSiteNameError(false);
      setLogoError(false);
      // setCroppedImage(null);
    }
  }, [modalShow]);

  return (
    <>
      <div className="org">
        <div className="org_header d-flex align-items-center justify-content-between">
          <h1 className="org_header_heading">Organization</h1>
        </div>
        <div className="org_table table-responsive table-border-0">
          <table className="table">
            <thead>
              <tr>
                <td className="org_table_column w-5 zone_table_heading"> </td>
                <td className="org_table_column w-25 zone_table_heading">
                  Organization Name
                </td>
                <td className="org_table_column w-25 zone_table_heading">
                  Company's website URL
                </td>
                <td className="org_table_column w-25 zone_table_heading">
                  Organization Logo
                </td>
                <td className="org_table_column w-20 text-center zone_table_heading">
                  Action
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="org_table_row w-5 zone_body_text">
                  <label
                    className="check_box ml-2"
                    htmlFor={`checkbox-${organizationData?.id}`}
                  >
                    <input
                      type="checkbox"
                      id={`checkbox-${organizationData?.id}`}
                      checked={checkedState[organizationData?.id] || false}
                      onChange={(e) =>
                        handleCheckboxChange(e, organizationData?.id)
                      }
                    />
                    <span className="checkbox_check"></span>
                  </label>
                </td>
                <td className="org_table_row w-25 zone_body_text">
                  {organizationData?.name}
                </td>
                <td className="org_table_row w-25 zone_body_text">
                  {organizationData?.website}
                </td>
                <td className="org_table_row w-25 zone_body_text">
                  <img
                    src={
                      organizationData?.logo
                        ? process.env.REACT_APP_MEDIA_URL_ORG +
                        organizationData?.logo
                        : logoImg
                    }
                    alt="logo"
                    className="logo_img"
                  />
                </td>
                <td className="org_table_row w-20 zone_body_text">
                  <div className="d-flex align-items-center justify-content-center">
                    <button
                      type="button"
                      className="action_btns mr-4"
                      onClick={handleEditClick}
                    >
                      <img src={editImg} alt="" className="mr-1" />
                      Edit
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <CustomModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        heading="Edit Organization"
        size="lg"
        body={
          <div className="row">
            <div className="col-lg-6">
              {/* <CustomFileUpload
                file={file?.viewImg || (organizationData?.logo ? process.env.REACT_APP_MEDIA_URL + organizationData.logo : null)}
                onFileChange={handleFileChange}
              /> */}

              {showCropper ? (
                <>
                  {/* <p>ImageCropper</p> */}
                  <ImageCropper
                    image={file.viewImg}
                    onCropComplete={handleCropComplete}
                    width={200} // Define the crop box width
                    height={100} // Define the crop box height
                    padding={50} // Default padding for the crop box
                  // coverStyle={{
                  //   objectFit: "cover",
                  //   borderRadius: "10px",
                  // }}
                  />
                </>
              ) : (
                <div>
                  {/* <p>CustomFileUpload</p> */}
                  {/* <img
                    src={croppedImage || file.viewImg || (organizationData?.logo ? process.env.REACT_APP_MEDIA_URL_ORG + organizationData.logo : null)}
                    alt="Cropped Logo"
                    className="cropped-img-preview"
                  /> */}
                  <CustomFileUpload
                    file={
                      file?.viewImg ||
                      (organizationData?.logo
                        ? process.env.REACT_APP_MEDIA_URL_ORG +
                        organizationData.logo
                        : null)
                    }
                    onFileChange={handleFileChange}
                  />
                </div>
              )}

              {logoError && (
                <div className="invalid-feedback d-block">
                  Logo is required.
                </div>
              )}
            </div>
            <div className="col-lg-6">
              <div className="form-group mt-4">
                <label className="innerlable mb_top">Organization Name</label>
                <input
                  type="text"
                  className={`form-control ${orgNameError ? "is-invalid" : ""}`}
                  placeholder="type here"
                  value={orgName}
                  onChange={(e) => {
                    setOrgName(e.target.value);
                    setOrgNameError(false); // Reset error when typing
                  }}
                />
                {orgNameError && (
                  <div className="invalid-feedback">
                    Organization name required.
                  </div>
                )}
              </div>
              <div className="form-group mt-4">
                <label className="innerlable mb_top">Enter your Company's website URL or the link to your Safety landing page</label>
                <input
                  type="text"
                  className={`form-control`}
                  // className={`form-control ${webSiteNameError ? "is-invalid" : ""}`}
                  placeholder="http://www.learnbyloci.com"
                  value={webSiteName}
                  onChange={(e) => {
                    setWebSiteName(e.target.value);
                    // setWebSiteNameError(false); // Reset error when typing
                  }}
                />
                {/* {webSiteNameError && (
                  <div className="invalid-feedback">
                    Website url required.
                  </div>
                )} */}
              </div>
              <CustomBtn
                buttonText="Save"
                className="mt-5"
                type="submit"
                id="organizationName"
                onClick={handleSave}
                disabled={!orgName.trim() || !webSiteName.trim() || !file.uploadedImg} // Disable button if organization name or logo is not filled
              />
            </div>
          </div>
        }
      />
    </>
  );
}

export default Organization;